import { Subscription } from '../subscription.model';
import { Courtesy, CheckIn } from '../../models';
import { StatusInfo } from '../status-info.model';
import { SUBSCRIPTION_STATUS_CONFIG, COURTESY_STATUS_CONFIG, CHECK_IN_STATUS_CONFIG } from '../constants';
import { CourtesyStatus, SubscriptionStatus, CheckInStatus } from '../enums';

/**
 * Gets the display information for a subscription's status
 */
export function getSubscriptionStatusByStatus(subscription: Pick<Subscription, 'status'>): StatusInfo {
  const status = subscription.status ?? SubscriptionStatus.UNKNOWN;
  return SUBSCRIPTION_STATUS_CONFIG[status];
}

/**
 * Gets the display information for a courtesy's status
 */
export function getCourtesyStatusByStatus(courtesy: Pick<Courtesy, 'status'>): StatusInfo {
  const status = courtesy.status ?? CourtesyStatus.UNKNOWN;
  return COURTESY_STATUS_CONFIG[status];
}

/**
 * Gets the display information for a check-in's status
 */
export function getCheckInStatusByStatus(checkIn: Pick<CheckIn, 'status'>): StatusInfo {
  const status = checkIn.status ?? CheckInStatus.UNKNOWN;
  return CHECK_IN_STATUS_CONFIG[status];
}
